import { useState, useEffect } from 'react';
import { supabase } from '../config/supabase';

export const useProducts = () => {
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchProducts = async () => {
      try {
        setLoading(true);
        console.log('Fetching products from Supabase...');

        // Fetch products from the database
        // Select specific columns to avoid RLS policy issues
        // Also join with categories and subcategories to get their names
        // Join with brands to filter out inactive brands
        const { data, error: fetchError } = await supabase
          .from('products')
          .select(`
            id, name, name_ar, slug, sku, description, img, images, attributes, price, currency, stock, weight_kg, status, created_at, updated_at, brand_id, dis, boost,
              category_id, category:categories(name_en, name_ar),
              subcategory_id, subcategory:subcategories(name_en, name_ar),
              brand:brands!inner(id, name, is_active, phone)
            `)
          .eq("brands.is_active", true) // filter on related table
          .order('created_at', { ascending: false });

        console.log('Products response - data:', data, 'error:', fetchError);

        if (fetchError) {
          console.error('Error fetching products:', fetchError);
          throw fetchError;
        }

        if (data) {
          setProducts(data);
        } else {
          console.log('No products found');
          setProducts([]);
        }
      } catch (err) {
        console.error('Error fetching products:', err);
        setError(err.message);
        setProducts([]);
      } finally {
        setLoading(false);
      }
    };

    fetchProducts();
  }, []);

  return { products, loading, error };
};
